import { use, useEffect, useContext, useRef, useState } from 'react';
// import EditComponent from './GiftCardEdit';
import { Button, Col, DatePicker, Form, Popover, Row, Select, Space, Table, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import system from '../../../config/systematic';
import getList from '../../universal/getList';
import antMessage from '../../../utils/extend/AntdNotification'
import DownloadExcel from '../../report/DownloadExcel';
import { SocketContext } from '../../../App';
import { useReactToPrint } from 'react-to-print';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

export default function BuyGiftCardReport() {
    const wmService: any = system.wmService;
    const [usageShop, setUsageShop] = useState<Array<any>>([]);
    const [rows, setRows] = useState<Array<any>>([]);
    const [branchStoreName, setBranchStoreName] = useState<string>("所有");
    let [userName, setUserName] = useState<string>("")
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;
    const [printScale, setPrintScale] = useState(1);

    const contentRef = useRef<HTMLDivElement>(null);
    const [form] = Form.useForm();
    const date = Form.useWatch("date", form) as any;
  
    

    //表头
    const columnsHead = [
        {
            title: '排序',
            dataIndex: 'serial',
            key: "serial",
            width: 4,
            header: "排序",
        },
        {
            title: '方案',
            dataIndex: 'planName',
            key: "planName",
            width: 20,
            header: "方案",
        },
        {
            title: '购入数',
            dataIndex: 'buyCount',
            key: "buyCount",
            width: 8,
            header: "购入数",
        },
        {
            title: '购入价',
            dataIndex: 'buyPrice',
            key: "buyPrice",
            width: 10,
            header: "购入价",
        },
        // {
        //     title: '购入值',
        //     dataIndex: 'buyFace',
        //     key: "buyFace",
        //     width: 10,
        //     header: "购入值",
        // },
        {
            title: '优惠',
            dataIndex: 'discount',
            key: "discount",
            width: 8,
            header: "优惠",
        },
        {
            title: '核销数',
            dataIndex: 'writeCount',
            key: "writeCount",
            width: 8,
            header: "核销数",
        },
        {
            title: '核销价',
            dataIndex: 'writePrice',
            key: "writePrice",
            width: 10,
            header: "核销价",
        },
        {
            title: '核销值',
            dataIndex: 'writeFace',
            key: "writeFace",
            width: 10,
            header: "核销值",
        },
        {
            title: '退款数',
            dataIndex: 'refundCount',
            key: "refundCount",
            width: 8,
            header: "退款数",
        },
        {
            title: '退款价',
            dataIndex: 'refundPrice',
            key: "refundPrice",
            width: 10,
            header: "退款价",
        },
        // {
        //     title: '退款值',
        //     dataIndex: 'refundFace',
        //     key: "refundFace",
        //     width: 10,
        //     header: "退款值",
        // },

        {
            title: '扣款',
            dataIndex: 'giftCardDeductionTypeName',
            key: "giftCardDeductionTypeName",
            width: 10,
            header: "扣款",
        },


    ];
    useEffect(() => {
        if (contextData?.currentBranchStoreId) {

            form.setFieldValue("branchStoreIds", [contextData?.currentBranchStoreId])
            setBranchStoreName(contextData?.currentBranchStoreName)
        }
        fetchApi.GET(
            wmService,
            {
                apiId: "branchStore",
                apiExtend: 'showListManage'
            }
        ).then(res => {
            if (res.success) {
                setUsageShop(res.data);
            }
        })
    }, []);
    const handlePrint = useReactToPrint({
        contentRef,
        documentTitle: '礼品卡报表',


    });
    const onFinish = () => {

        setIsLoading(true)

        form.validateFields()
            .then(async (values: any) => {

                fetchApi.GET(wmService, {
                    apiId: "giftCard",
                    apiExtend: 'giftCardReport',
                    apiData: {
                        ...values,
                        // branchStoreId
                    }
                }).then((res) => {

                    if (res.success) {

                        setRows(res.data)
                        setUserName(res.userName)
                    }
                    setIsLoading(false)
                }).catch((err) => {
                    antMessage("error", "失败", err.message);
                    setIsLoading(false)
                })

            })
            .catch((err) => {
                antMessage("error", "失败", JSON.stringify(err))
                setIsLoading(false)
            })

    }
    const changedBranchStore = (e: any, option: any) => {
        let branchStoreName: Array<any> = []
        for (let i = 0; i < option?.length; i++) {
            branchStoreName.push(option[i].children)
        }


        setBranchStoreName(branchStoreName.join(","))

    }


    return (
        <div>
            <Form form={form} initialValues={{ dataStatusType: 1 }} onFinish={onFinish}>
                <Row>
                    <Col span={12}>

                        <Form.Item
                            name="date"
                            label="日期"
                        >
                            <RangePicker
                                allowClear
                                // defaultValue={moment(data.bookingDate)}
                                format="YYYY-MM-DD"
                            />
                        </Form.Item>
                    </Col>




                    <Col span={12}>

                        <Form.Item
                            name="branchStoreIds"
                            label="门店"

                        >
                            <Select
                                allowClear
                                onChange={changedBranchStore}
                                // style={{ width: "300px" }}
                                // orderTypeData
                                mode="multiple"
                                showSearch
                                placeholder="请选择状态!"
                                optionFilterProp="children"

                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(usageShop, 'branchStoreName')}
                            </Select>
                        </Form.Item>
                    </Col>


                    <Col span={4}>
                        <Form.Item >
                            <Space>

                                <Button loading={isLoading} htmlType="submit">
                                    统计
                                </Button >
                                <Button onClick={() => DownloadExcel(rows, "giftCardReport", { columnsHead, branchStoreName, userName, date: form.getFieldValue("date") })}>下载EXCEL文件</Button>
                                <Button onClick={handlePrint} type="default">打印</Button>
                                {/* purContrast */}
                            </Space>
                        </Form.Item>
                    </Col>

                </Row>
            </Form>

            <div style={{ marginTop: "20px" }}>
                <Table
                    scroll={{ x: "100%", y: 950 }}
                    pagination={false}
                    // rowKey={(record: any, index: any) => {
                    //     return index
                    // }}
                    columns={columnsHead}
                    dataSource={rows}

                >
                </Table>

            </div>
            <div
                ref={contentRef}
                className="print-table"
                style={{
                    display: 'none',
                    transform: `scale(${printScale})`,
                    transformOrigin: 'top left',
                    width: printScale < 1 ? `${100 / printScale}%` : '100%'
                }}
            >
                <div style={{ fontSize: 18, textAlign: "center", marginBottom: 10 }}>礼品卡统计</div>
                <div style={{ fontSize: 14, textAlign: "center", marginBottom: 10, display: "flex", justifyContent: "space-between", }}>
                    {/* <div>  {queryCriteria?.timeNameA}: {moment(queryCriteria?.startTime).format('YYYY-MM-DD')}  至 {moment(queryCriteria?.endTime).format('YYYY-MM-DD')}</div> */}
                    {/* <div>部门：{queryCriteria.deptName}</div> */}
                    <div>日期:{date ?`${dayjs(date[0]).format('YYYY-MM-DD')}~${dayjs(date[1]).format('YYYY-MM-DD')}` : "所有"}</div>

                    <div>分店:{branchStoreName}</div>



                </div>
                <Table
                    pagination={false}
                    rowKey={(record: any) => record.id}
                    columns={columnsHead} dataSource={rows}

                >
                </Table>

                <style dangerouslySetInnerHTML={{
                    __html: `
                    @media print {
                       
                        /* 2. 隐藏非打印元素 */
                        .no-print, .screen-table {
                            display: none !important;
                        }

                        /* 3. 显示打印表格 */
                        .print-table {
                            display: block !important;
                        }

                        /* 4. ✅ 核心：强制白底黑字 */
                        .print-table table {
                            border-collapse: collapse !important;
                            width: 100% !important;
                            table-layout: auto !important; /* 自动分配列宽 */
                        }

                        /* 表头：白底黑字加粗 */
                        .print-table .ant-table-thead > tr > th {
                            background: #ffffff !important; /* 强制白底 */
                            color: #000000 !important; /* 强制黑字 */
                            border: 1px solid #000000 !important;
                            font-weight: bold !important;
                            font-size: 12px !important;
                            padding: 6px 8px !important;
                        }

                        /* 单元格：白底黑字 */
                        .print-table .ant-table-tbody > tr > td {
                            background: #ffffff !important; /* 强制白底 */
                            color: #000000 !important; /* 强制黑字 */
                            border: 1px solid #000000 !important;
                            font-size: 11px !important;
                            padding: 4px 8px !important;
                            white-space: nowrap !important; /* 防止文字换行撑大表格 */
                        }

                        /* 5. 防止内容跨页截断 */
                        .print-table tr {
                            page-break-inside: avoid !important;
                        }

                        /* 6. 强制打印背景色（解决浏览器省墨模式问题） */
                        body {
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }

                        /* 7. 清除Antd残留样式 */
                        .print-table .ant-table-cell-fix-left,
                        .print-table .ant-table-cell-fix-right {
                            position: static !important;
                        }
                        .print-table .ant-table-container,
                        .print-table .ant-table-content,
                        .print-table .ant-table-body {
                            overflow: visible !important;
                            max-height: none !important;
                        }
                    }
                `
                }} />
            </div>

        </div>


    )
}
